import type { ConversationPriorityChangedEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import WarningIcon from "@redotech/redo-icons/alert-triangle.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { formatSentenceCase } from "@redotech/util/string";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const ConversationPriorityChangedEvent = memo(
  function ConversationPriorityChangedEvent({
    event,
    data,
  }: {
    event: ConversationTimelineEventResponse;
    data: ConversationPriorityChangedEventData;
  }) {
    const prev = formatSentenceCase(data.previousPriority ?? "none");
    const next = formatSentenceCase(data.newPriority ?? "none");

    return (
      <Flex align="flex-start" className={styles.card} gap="sm">
        <Flex
          align="center"
          className={`${styles.icon} ${styles.iconOrange}`}
          justify="center"
        >
          <WarningIcon />
        </Flex>
        <Flex className={styles.content} dir="column" gap="xxs">
          <Text fontSize="xs" fontWeight="medium" textColor="primary">
            Priority changed from {prev} to {next}
          </Text>
          <EventTimestamp event={event} />
        </Flex>
      </Flex>
    );
  },
);
